import React from 'react';
const AdminNews = () => <div className="min-h-screen p-8">Admin News Management</div>;
export default AdminNews; 